// extracted by mini-css-extract-plugin
export default {"meetingEndedContainer":"Ended_meetingEndedContainer__oXpKL"};